<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs10, sm9, md8, lg8, text-xs-center)
          v-card(flat)
            breadcrumb(back='page9-1')
            v-card-text.label16tt.withDivider(style='margin-top:-58px;')
              | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
            v-card-text.titulo36Book.pa-0.ma-0.pb-5
              | ¿Qué Aprendí en esta lección?
            v-card-media(height='300px', src='assets/TCH-L2.10-portada.jpg')
            v-card-text.parrafoDestacado18.text-xs-left
              | La siguiente actividad te ayudará a reforzar tus conocimientos sobre los seguros, variables y requisitos que intervienen en un plan de contratación de un Crédito Hipotecario. 
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage('page10-2')")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false,
      
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    }
  },
};
</script>
